<template lang="pug">
    .home(v-observe-visibility='visibilityChanged')
        ScrollTrigger(
            :color='"black"',
            )
        .home_star
            .home_star-animation(ref='star')
                img.home_star-img(src='../assets/img/star-home.svg')
        .home_intro(ref='homeIntro')
            .intro
                .intro_text(v-html='intro.text.join("")')
                router-link.intro_link(
                    :to='`/${link}`'
                    v-html='intro.link'
                    )
</template>

<script>
import {gsap} from 'gsap';
import {intro, parts} from '@/assets/data/menu.json';
export default {
    components: {
        ScrollTrigger: () => import('@/components/ScrollTrigger.vue')
    },
    mounted() {
        this.createAnimation();
    },
    beforeDestroy() {
        this.destroyAnimation();
    },
    data() {
        return {
            intro,
            link: parts[0]['id']
        };
    },
    methods: {
        visibilityChanged(isVisible) {
            if (!isVisible) this.destroyAnimation();
            if (isVisible) this.createAnimation();
        },
        createAnimation() {
            if (this.timeline) return;
            this.timeline = gsap.timeline();
            this.timeline
                .fromTo(this.$refs.star, {scale: 1, rotate: 0}, {ease: 'none', duration: 4, scale: 35, rotate: 360}, 1)
                .fromTo(this.$refs.homeIntro, {opacity: 0}, {ease: 'none', opacity: 1}, 2.5);
        },
        destroyAnimation() {
            if (!this.timeline) return;
            this.timeline.kill();
            this.timeline = null;
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
.home {
    background: var(--color-black);
    min-height: 100vh;
    min-width: 100vw;
    display: flex;
    &_star {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(30vw + 30vh);
    }
    &_star-img {
        display: block;
        width: 100%;
        height: auto;
    }
    &_intro {
        max-width: calc(var(--grid-column) * 15);
        padding: 0 var(--grid-column);
        margin: auto;
        width: 100%;
        position: relative;
        max-height: calc(var(--vh) * 100);
        @media screen and (--viewport-mobile-l), (--viewport-mobile-lp) {
            overflow: scroll;
            margin: 0 auto;
            padding: 50px var(--grid-column-mobile) 30px;
        }
    }
}
.intro {
    color: var(--color-white);
    font-size: 1rem;
    &_text {
        p:not(:last-child) {
            margin-bottom: 1.3em;
        }
    }
    &_link {
        display: block;
        width: 100%;
        padding: 3em 0;
        font-weight: 800;
        text-transform: uppercase;
        font-size: 14px;
        font-family: var(--font-accent);
        text-align: center;
        @media screen and (--viewport-mobile-l) {
            text-transform: none;
            font-size: 15px;
        }
    }
}
</style>
